// 任务类型filter
export function taskTypeFilter(state, te) {
  switch (state) {
    case 0:
      return te("filter.exam");
    case 1:
      return te("filter.exercise");
    case 2:
      return te("filter.contest");
    default:
      return te("filter.exercise");
  }
}

// 任务状态filter
export function taskStateFilter(state, te) {
  switch (state) {
    case 0:
      return te("filter.noStart");
    case 1:
      return te("filter.doing");
    case 2:
      return te("filter.marking");
    case 3:
      return te("filter.end");
    default:
      return te("filter.null");
  }
}

// 任务状态badge颜色
export function taskBadgeFilter(state) {
  switch (state) {
    case 0:
      return "info";
    case 1:
      return "primary";
    case 2:
      return "success";
    case 3:
      return "danger";
    default:
      return "primary";
  }
}

// 课程开放类型filter
export function lessonTypeTextFilter(state) {
  switch (state) {
    case 0:
      return "免费";
    case 1:
      return "付费";
    default:
      return "未知";
  }
}

// 班级列表过滤器
export function groupNameFilter(classList) {
  let res = "";
  for (let i = 0; i < classList.length; i++) {
    res += `${classList[i]} ; `;
  }
  return res;
}

// 日期转换
export function timeFormatter(time) {
  let res = "";
  res = time.indexOf("T")
    ? `${time.split("T")[0]} ${time.split("T")[1].split(".")[0]}`
    : time;
  return res;
}
// 任务状态badge颜色
export function compBadgeFilter(state) {
  switch (state) {
    case 0:
      return "info";
    case 1:
      return "primary";
    case 2:
      return "success";
    case 3:
      return "danger";
    default:
      return "info";
  }
}

export function fileNameFilter(link) {
  if (link.includes("/")) {
    return link.split("/").pop();
  }
  return link;
}
